import { PatchPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export const getTimesheetDispute = async (
  params: { [key: string]: string | number | number[] } | undefined
) => {
  const res = await apiCall.get(
    API_URL.TIMESHEET_DISPUTE.GET_TIMESHEET_DISPUTE,
    params
  );
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};

export const getTimesheetSolveDispute = async (
  uuid: string,
  payload: PatchPayloadProps
) => {
  const url = API_URL.TIMESHEET_DISPUTE.TIMESHEET_DISPUTE_SOLVE.replace(
    "timesheetUuid",
    uuid
  ).replace(/[{}]/g, "");
  const res = await apiCall.patch(url, payload);
  const responseData = await handleResponse(res);
  if (responseData.ok) {
    return responseData?.data;
  } else {
    return responseData;
  }
};
